import React, { FC, memo } from 'react';
import { ReactReduxContext, useSelector } from 'react-redux';
import { Stage as PixiStage } from '@inlet/react-pixi';
import useImageLoad from 'hooks/useImageLoad';
import { ContextBridge, BackgroundComponent, PersonComponent, PixiSpinner } from 'components';

import {
  getGlobal,
  getPersonsLoaded,
  getBGLoaded,
  getPersonsLoading,
  getBGLoading,
  loadPersons,
  loadBackgrounds,
  setPersonsLoaded,
  setBGLoaded,
} from 'store';
import { BubbleWrapper } from '../BubbleWrapper';

type Props = {
  play: boolean;
};

export const Scene: FC<Props> = memo(({ play }) => {
  const { height, width } = useSelector(getGlobal);
  const isPersonsLoaded = useSelector(getPersonsLoaded);
  const isPersonsLoading = useSelector(getPersonsLoading);
  const isBGLoaded = useSelector(getBGLoaded);
  const isBGLoading = useSelector(getBGLoading);

  const personsSpritesList = useImageLoad(loadPersons, setPersonsLoaded);
  const bgSpritesList = useImageLoad(loadBackgrounds, setBGLoaded);

  if ((!isPersonsLoaded && !isPersonsLoading) || (!isBGLoading && !isBGLoaded)) {
    return (
      <div className="errorBlock" style={{ height, width }}>
        Something went wrong!
      </div>
    );
  }

  return (
    <ContextBridge
      Context={ReactReduxContext}
      render={(ch) => (
        <PixiStage
          height={height}
          width={width}
          options={{ resolution: window?.devicePixelRatio || 1 }}
        >
          {ch}
        </PixiStage>
      )}
    >
      {isPersonsLoading && isBGLoading && <PixiSpinner />}
      <>
        <BackgroundComponent bgSpritesList={bgSpritesList} />
        <PersonComponent personsSpritesList={personsSpritesList} />
        {play ? <BubbleWrapper /> : null}
      </>
    </ContextBridge>
  );
});
